import React from 'react';
import { ResetFilterButton } from './styled';

export default class ResetFilter extends React.Component{
    render(){
        return <ResetFilterButton onClick={this.props.onClick}>Reset Filter</ResetFilterButton>
    }
}